const CONSTANTS = {
    total_fileuploads: 5
};

export default CONSTANTS;